export const dDClientToken = 'pubb30d43df2ce3ab9998c00d90c3c0f95b';
export const dDApplicationId = '92afa863-7c64-4d4c-879c-f796ed1ddf07';
export const dDSite = 'datadoghq.com';
export const dDService = 'creator';
